import React from 'react';

export interface ButtonProps {
  color?: string;
  name?: string;
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
  type?: 'button' | 'submit' | 'reset';
  variant?: 'primary' | 'secondary' | 'outline' | 'white';
  size?: 'sm' | 'md' | 'lg';
}

export const Button: React.FC<ButtonProps> = ({
  color,
  name,
  children,
  onClick,
  className = '',
  type = 'button',
  variant = 'primary',
  size = 'md',
}) => {
  const isWhite = color === '#fff' || color === 'white' || variant === 'white';
  const isOutline = variant === 'outline';
  const isSecondary = variant === 'secondary';

  let baseStyle =
    'inline-flex items-center justify-center font-medium transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-[#0D7893] focus:ring-offset-2 active:scale-[0.98] select-none';

  let sizeStyle = 'px-6 py-3 text-sm md:text-base rounded-xl';
  if (size === 'sm') sizeStyle = 'px-4 py-2 text-xs md:text-sm rounded-lg';
  if (size === 'lg') sizeStyle = 'px-8 py-3.5 text-base md:text-lg rounded-2xl';

  let colorStyle = 'bg-[#0D7893] text-white hover:bg-[#0A6278] shadow-md hover:shadow-lg shadow-[#0D7893]/20';
  if (isWhite) {
    colorStyle = 'bg-white text-[#0D7893] border border-slate-200 hover:bg-slate-50 hover:border-slate-300 shadow-sm';
  } else if (isOutline) {
    colorStyle = 'border-2 border-[#0D7893] text-[#0D7893] hover:bg-[#0D7893]/10 bg-transparent';
  } else if (isSecondary) {
    colorStyle = 'bg-[#0D7893]/10 text-[#0D7893] hover:bg-[#0D7893]/20';
  }

  return (
    <button
      type={type}
      name={name}
      onClick={onClick}
      className={`${baseStyle} ${sizeStyle} ${colorStyle} ${className}`}
    >
      {children}
    </button>
  );
};

export default Button;
